<template>
    <section class="section-pic-time-hero background mobile:pt-8 tablet:pt-20">
        <!--Video Background-->
        <VimeoEmbed
            class="mx-auto container max-w-5xl tabletLandscape:mb-40"
            :video-url="sectionHero.videoSources.videoUrl"
            :video-poster-url="sectionHero.videoSources.videoPosterUrl"
            video-id="hero-background-video"
        />
    </section>
</template>

<script>
import VimeoEmbed from '@whisper/components/VimeoEmbed';

export default {
  components: {
    VimeoEmbed,
  },
  props: {
    sectionHero: {
      type: Object,
      required: true,
      heroContent: {
        type: Object,
        required: true,
      },
      videoSources: {
        type: Object,
        required: true,
      },
    },
  },
};
</script>

<style scoped>
section {
    min-height: auto;
}
</style>
